/**
 * APP LAYOUT
 *
 * Root layout component: sidebar + main content area.
 * The main content area has the Colony "inset panel" styling
 * with rounded corners and a subtle shadow.
 */

import { ColonySidebar } from "@/components/ColonySidebar";
import { SetupChecklist } from "@/components/onboarding/SetupChecklist";
import { isTauri } from "@/hooks/usePlatform";

export function AppLayout({ children }: { children: React.ReactNode }) {
  const tauriActive = isTauri();

  return (
    <div className="flex flex-row h-screen overflow-hidden" style={{ background: "var(--colony-bg, hsl(var(--background)))" }}>
      <ColonySidebar />

      <main
        className="flex flex-1 flex-col overflow-hidden min-w-0"
        style={{
          background: "var(--gradient-content, var(--colony-content-bg, hsl(var(--card))))",
          borderRadius: "var(--colony-content-radius, 0)",
          margin: "8px 8px 8px 0",
          boxShadow: "var(--colony-content-shadow)",
        }}
      >
        <SetupChecklist />
        {children}
      </main>
    </div>
  );
}
